export const EfsAccounts = [
  { value: "C1", label: "C1" },
  { value: "FOX", label: "FOX" },
];

export const isEfsAccount = (value: unknown): value is "C1" | "FOX" =>
  value === "C1" || value === "FOX";
